import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './ConfirmationModal.css';
import {
    Button, Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControlLabel,
    styled,
} from '@mui/material';
import LoaderCustomFixed from './LoaderCustomFixed';
import InfoIcon from '@mui/icons-material/Info';
import {FaCheck, FaTimes} from 'react-icons/fa'; // Importing icons for Yes and No

const StyledDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialog-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 15,
        zIndex: 50000,
    },
    '& .MuiPaper-root': {
        padding: theme.spacing(2),
        borderRadius: 15,
        zIndex: 50000,
    },
}));

const ConfirmationModal = ({
                               isOpen,
                               onRequestClose,
                               caseID = null,
                               onConfirm,
                               modalText = 'დარწმუნებული ხართ?',
                               fullName = "",
                               dateTime = "",
                               previewHtml = null,
                               hasCheckBox = false,
                               accept = false,
                               onChange
                           }) => {
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const [isNoButtonDisabledAfterAction, setIsNoButtonDisabledAfterAction] = useState(false);
    const [showPreview, setShowPreview] = useState(false);

    const handleOpenCase = () => {
        const url = `/dashboard/mycases/casemanager?id=${caseID}`;
        window.open(url, '_blank');
    };

    const generateObjectHtml = (template, replacements) => {
        if (!template) {
            return '';
        }

        return Object.entries(replacements).reduce(
            (html, [key, value]) => html.replaceAll(`{${key}}`, value),
            template
        );
    };


    if (!isOpen) {
        return null;
    }

    const handleConfirm = async () => {
        if (isButtonDisabled) {
            return;
        }

        setButtonDisabled(true);
        setIsNoButtonDisabledAfterAction(true);
        try {
            await onConfirm();
        } catch (error) {
        } finally {
            setTimeout(() => {
                setButtonDisabled(false);
                setIsNoButtonDisabledAfterAction(false);
            }, 500);
        }
    };

    return (
        <>
            <Dialog
                open={showPreview && previewHtml}
                onClose={() => setShowPreview(false)}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {width: '90%', maxWidth: '950px'}
                }}
            >
                <DialogContent dividers>
                    <div dangerouslySetInnerHTML={{__html: generateObjectHtml(previewHtml, {dateTime, fullName})}}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowPreview(false)} color="primary">
                        დახურვა
                    </Button>
                </DialogActions>
            </Dialog>


            <StyledDialog
                open={isOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        onRequestClose();
                    }
                }}
                aria-labelledby="confirmation-dialog-title"
                disableEscapeKeyDown={true}
                onMouseDown={(event) => event.stopPropagation()}
            >
                {!isNoButtonDisabledAfterAction && (
                    <DialogTitle id="confirmation-dialog-title">დასტური</DialogTitle>
                )}

                {isNoButtonDisabledAfterAction ? (
                    <DialogContent>
                        <LoaderCustomFixed/>
                    </DialogContent>
                ) : (
                    <DialogContent>
                        <DialogContentText>{modalText}</DialogContentText>
                        {caseID && (
                            <Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleOpenCase}
                                    style={{margin: '10px 0', width: '500px'}}
                                    endIcon={<InfoIcon/>}
                                >
                                    უნომრო ობიექტის ნახვა
                                </Button>
                            </Button>
                        )}
                    </DialogContent>
                )}
                {previewHtml && (
                    <Button
                        variant="outlined"
                        onClick={() => setShowPreview(true)}
                        style={{marginTop: 10}}
                    >
                        დოკუმენტის ნახვა
                    </Button>
                )}
                {hasCheckBox && (
                    <FormControlLabel
                        style={{marginRight: 70}}
                        control={<Checkbox checked={accept}
                                           onChange={onChange}/>}
                        label="მსურს მრავალჯერადად დამატება"
                    />
                )}

                <DialogActions>
                    <div style={{display: 'flex', gap: 10}}>
                        <button
                            onClick={handleConfirm}
                            disabled={isButtonDisabled}
                            className="ok-button centered-button"
                        >
                            <FaCheck/>
                            <span>კი</span>
                        </button>
                        <button
                            disabled={isNoButtonDisabledAfterAction}
                            onClick={onRequestClose}
                            className="cancel-button centered-button"
                        >
                            <FaTimes/>
                            <span>არა</span>
                        </button>
                    </div>
                </DialogActions>
            </StyledDialog>
        </>
    );
};

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
